import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as automationActionTransformer } from "./AutomationAction";

export const AutomationTaskValidationSchema = Yup.object().shape({});

export const AutomationTaskObjectSchema = {
    id: null,
    uuid: null,
    contentType: null,
    fromWorkflow: null,
    toWorkflow: null,
    transition: null,
    metaField: null,
    metaTarget: null,
    actions: [],
};

export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let task = Object.assign({}, AutomationTaskObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        contentType: requestData.content_type,
        fromWorkflow: requestData.from_workflow,
        toWorkflow: requestData.to_workflow,
        transition: requestData.transition_type,
        metaField: requestData.meta_field,
        metaTarget: requestData.meta_target,
    });

    if (requestData.actions) {
        let actions = automationActionTransformer(requestData.actions);
        task = Object.assign({}, task, { actions: actions });
    }

    return task;
}
